import { useEffect } from 'react';

/**
 * Workaround for a Chakra v3 + React 19 StrictMode interaction where Ark UI's
 * scroll-lock counter can drift and leave body styles stuck (pointer-events: none,
 * overflow: hidden, data-scroll-locked) after a Drawer or Dialog closes.
 *
 * After the close animation should have finished, if no other dialog is still
 * open in the document, force-restore body styles. Safe no-op otherwise.
 *
 * Delete this once Chakra/Ark UI ships a StrictMode-stable fix.
 */
export default function useDialogCleanup(isOpen: boolean): void {
  useEffect(() => {
    if (isOpen) return;
    const timer = window.setTimeout(() => {
      const stillOpen = document.querySelector('[data-state="open"][role="dialog"]');
      if (stillOpen) return;
      const body = document.body;
      if (body.style.pointerEvents === 'none') body.style.pointerEvents = '';
      if (body.style.overflow === 'hidden') body.style.overflow = '';
      [...body.attributes]
        .filter((a) => a.name.startsWith('data-scroll-locked'))
        .forEach((a) => body.removeAttribute(a.name));
    }, 350);
    return () => window.clearTimeout(timer);
  }, [isOpen]);
}
